<div class="ui-g" [formGroup]="parentForm">
  <div class="ui-g-9">
    <div class="ui-g">
      <div class="ui-g-offset-4 ui-g-8">
        <h3 class="m-t-0">{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.MEMBERSHIP_HEADER' | translate}}</h3>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_FEE_CATEGORY_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'SELECT_FEE_CATEGORY.LABEL' | translate}}</label>
      </div>
      <div class="ui-g-8">
        <wsd-select-fee-category [parentForm]="parentForm">
        </wsd-select-fee-category>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_EVENT_CATEGORY_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'SELECT_EVENT_CATEGORY.LABEL' | translate}}</label>
      </div>
      <div class="ui-g-8">
        <wsd-select-event-category [parentForm]="parentForm">
        </wsd-select-event-category>
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-offset-4 ui-g-8">
        <h3>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.TECH_INFO_HEADER' | translate}}</h3>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_ACRONYM_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.ORG_ACRONYM_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('acronym')">
          <input pInputText formControlName="acronym">
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['SUSPENSION_STATUS_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'SELECT_SUSPENSION_STATUS.LABEL' | translate}}</label>
      </div>
      <div class="ui-g-8">
        <wsd-select-suspension-status [parentForm]="parentForm">
        </wsd-select-suspension-status>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_SUSPENSION_INFORMATION_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.SUSPENSION_INFORMATION_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('suspensionInformation')">
          <textarea pInputTextarea
                    maxlength="4096"
                    [autoResize]="true"
                    rows="5"
                    formControlName="suspensionInformation">
          </textarea>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_CONFIDENTIAL_INFORMATION_UPDATE']">
      <div class="ui-g-4">
        <label><i class="fa fa-eye-slash suspension-conf-icon"></i>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.CONFIDENTIAL_INFORMATION_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('confidentialInformation')">
          <textarea pInputTextarea
                    maxlength="4096"
                    [autoResize]="true"
                    rows="5"
                    formControlName="confidentialInformation">
          </textarea>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_ORDER_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.ORDER' | translate}}</label>
      </div>
      <div class="ui-g-2">
        <gs-extended-input [control]="parentForm.get('order')">
          <input pInputText formControlName="order">
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_PREFERRED_GLOBAL_LANGUAGE_UPDATE']">
      <div class="ui-g-4">
        <label> {{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.PREFERRED_GLOBAL_LANGUAGE_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-select-language-ac [parentForm]="parentForm"
                                [allowedLanguages]="languageFilters.global"
                                [controlName]="'globalLanguage'">
        </wsd-select-language-ac>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_PREFERRED_WORKING_LANGUAGE_UPDATE']">
      <div class="ui-g-4">
        <label> {{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.PREFERRED_WORKING_LANGUAGE_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-select-language-ac [parentForm]="parentForm"
                                [allowedLanguages]="languageFilters.working"
                                [controlName]="'workingLanguage'">
        </wsd-select-language-ac>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['ORGANIZATION_CURRENCY_UPDATE']">
      <div class="ui-g-4">
        <label> {{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.CURRENCY_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-select-currency-ac [parentForm]="parentForm"
                                [controlName]="'currency'">
        </wsd-select-currency-ac>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['NOTES_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.NOTES_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('notes')">
          <textarea pInputTextarea
                    maxlength="4096"
                    [autoResize]="true"
                    rows="5"
                    formControlName="notes">
          </textarea>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['FOUNDING_DATE_OF_ORGANIZATION_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.FOUNDING_DATE_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-3">
        <gs-extended-input [control]="parentForm.get('foundingDate')">
          <p-calendar wsdUseUtc formControlName="foundingDate">
          </p-calendar>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g" *gsShowIfHasPermission="['NSO_SETUP_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.FEDERATION_LABEL' | translate}}</label>
      </div>
      <div class="ui-g-4">
        <p-checkbox formControlName="federation"
                    binary="true"
                    class="m-t-10">
        </p-checkbox>
      </div>
    </div>
    <div class="ui-g" *gsShowIfHasPermission="['POTENTIAL_MEMBER_ORGANIZATION_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.POTENTIAL_MEMBER_LABEL' | translate}}</label>
      </div>
      <div class="ui-g-4">
        <p-checkbox formControlName="potentialMember"
                    binary="true"
                    class="m-t-10">
        </p-checkbox>
      </div>
    </div>
    <div class="ui-g" *gsShowIfHasPermission="['MEMBER_OF_WAGGGS_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.WAGGGS_MEMBER_LABEL' | translate}}</label>
      </div>
      <div class="ui-g-4">
        <p-checkbox formControlName="wagggsMember"
                    binary="true"
                    class="m-t-10">
        </p-checkbox>
      </div>
    </div>
    <!--<div class="ui-g m-b-0">-->
    <!--<div class="ui-g-4">-->
    <!--<label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.SAGNO_CENSUS_LABEL' | translate}}</label>-->
    <!--</div>-->
    <!--<div class="ui-g-4">-->
    <!--<p-checkbox formControlName="wagggsStatus"-->
    <!--binary="true"-->
    <!--class="m-t-10">-->
    <!--</p-checkbox>-->
    <!--</div>-->
    <!--</div>-->
    <div *gsShowIfHasPermission="['WAGGGS_SPECIAL_STATUS_NOTE_UPDATE']">
      <div class="ui-g m-b-0" *ngIf="parentForm.get('wagggsMember').value === true">
        <div class="ui-g-4">
          <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.SPECIAL_STATUS_NOTE' | translate }}</label>
        </div>
        <div class="ui-g-8">
          <gs-extended-input [control]="parentForm.get('wagggsDescription')">
            <textarea pInputTextarea
                      maxlength="1024"
                      [autoResize]="true"
                      rows="5"
                      formControlName="wagggsDescription">
            </textarea>
          </gs-extended-input>
        </div>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['YEAR_OF_WOSM_MEMBERSHIP_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.WOSM_MEMBERSHIP_YEAR_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('wosmMembershipYear')">
          <input pInputText formControlName="wosmMembershipYear">
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['WOSM_MEMBERSHIP_HISTORY_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.WOSM_MEMBERSHIP_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('wosmMembership')">
          <textarea pInputTextarea
                    maxlength="4096"
                    [autoResize]="false"
                    rows="5"
                    formControlName="wosmMembership">
          </textarea>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['HOSTED_PAST_WOSM_EVENTS_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.HOSTED_PAST_WOSM_EVENTS' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('pastWosmEvents')">
          <textarea pInputTextarea
                    maxlength="4096"
                    [autoResize]="false"
                    rows="5"
                    formControlName="pastWosmEvents">
          </textarea>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['KEY_SUMMARY_OF_NSO_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.KEY_SUMMARY_OF_NSO_LABEL' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <gs-extended-input [control]="parentForm.get('summaryList')">
          <textarea pInputTextarea
                    maxlength="4096"
                    [autoResize]="false"
                    rows="5"
                    formControlName="summaryList">
          </textarea>
        </gs-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0" *gsShowIfHasPermission="['VISIBLE_IN_DIRECTORY_UPDATE']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.DETAIL_INFO.VISIBLE_IN_DIRECTORY' | translate}}</label>
      </div>
      <div class="ui-g-4">
        <p-checkbox formControlName="visibleInDirectory"
                    binary="true"
                    class="m-t-10">
        </p-checkbox>
      </div>
    </div>
  </div>
</div>
